export default function PeopleList({ people = [] }) {
  const getURL = (linkedIn) => {
    if (!linkedIn) return null;
    if (linkedIn.startsWith('https://')) return linkedIn;
    if (linkedIn.startsWith('www.')) return `https://${linkedIn}`;
    if (linkedIn.startsWith('linkedin.com/')) return `https://${linkedIn}`;
    return `https://linkedin.com/in/${linkedIn}`;
  }

  return (
    <ul className="grid sm:grid-cols-2 gap-6 ">
      {people.map((p, idx) => (
        <li key={idx} className="
          relative p-6 border border-gray-400 rounded-md 
          transition-shadow hover:shadow-lg hover:shadow-gray-300/70 dark:hover:glow-basic
          cursor-none fade-up
        " style={{ animationDelay: `${420 + idx * 120}ms` }}>
          {p.linkedinURL && (
            <a
              href={getURL(p.linkedinURL)}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Open ${p.name}'s LinkedIn profile`}
              className="absolute top-3 right-3 opacity-50 hover:opacity-100 transition-opacity p-1 rounded-none"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-black dark:text-white">
                <path d="M14 3h7v7" />
                <path d="M10 14L21 3" />
                <path d="M21 21H3V3" />
              </svg>
            </a>
          )}
          <div className="text-lg sm:text-xl md:text-2xl font-semibold">{p.name}</div>
          {p.title && <div className="text-sm sm:text-md md:text-lg font-subheading text-black-muted dark:text-white-muted">{p.title}</div>}
          {p.bio && <p className="mt-4 text-sm sm:text-md md:text-lg text-black-muted dark:text-white-muted leading-7">{p.bio}</p>}
        </li>
      ))}
    </ul>
  );
}
